//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList } from '@/api/MLXC/countryGovern/suggestManage';
import waves from '@/directive/waves'; // 水波纹指令

import complaintDetail from './detail';
import complaintDispatch from './dispatch';
import complaintTransfer from './transfer';
import complaintDispose from './dispose';
import complaintReturnVisit from './returnVisit';
export default {
  components: {
    complaintDetail: complaintDetail,
    complaintDispatch: complaintDispatch,
    complaintTransfer: complaintTransfer,
    complaintDispose: complaintDispose,
    complaintReturnVisit: complaintReturnVisit
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      complaintId: '',
      flowNum: '',
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        pageTypePc: 2
      },
      situationOption: [{
        name: '紧急',
        value: 0
      }, {
        name: '一般',
        value: 1
      }],
      statusOption: [{
        name: '未处理',
        value: 0
      }, {
        name: '处理中',
        value: 1
      }, {
        name: '已处理',
        value: 2
      }],
      visitOption: [{
        name: '未回访',
        value: 1
      }, {
        name: '已回访',
        value: 2
      }],
      sourceOption: [// { name: '微信', value: 1 },
      {
        name: '电话',
        value: 2
      }, {
        name: '现场登记',
        value: 3
      }],
      title: '',
      multipleSelection: [],
      dialogFormVisible: false,
      dialogFormDispatchVisible: false,
      dialogFormTransferVisible: false,
      dialogFormDisposeVisible: false,
      dialogFormReturnVisible: false
    };
  },
  created: function created() {
    if (location.hash === '#/complaintManage/suggestQuery') {
      this.listQuery.sysType = 2;
    } else {
      this.listQuery.sysType = 1;
    }

    this.getList();
  },
  methods: {
    handCancle: function handCancle(reload) {
      this.getList();
      this.dialogFormVisible = false;
      this.dialogFormDispatchVisible = false;
      this.dialogFormTransferVisible = false;
      this.dialogFormDisposeVisible = false;
      this.dialogFormReturnVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCheck: function handleCheck(id, flowNum) {
      this.complaintId = id;
      this.flowNum = flowNum;
      this.title = '投诉详情';
      this.dialogFormVisible = true;
    },
    handleDispatch: function handleDispatch(id) {
      this.complaintId = id;
      this.title = '派工';
      this.dialogFormDispatchVisible = true;
    },
    handleTransfer: function handleTransfer(id) {
      this.complaintId = id;
      this.title = '转派';
      this.dialogFormTransferVisible = true;
    },
    handleDispose: function handleDispose(id) {
      this.complaintId = id;
      this.title = '处理';
      this.dialogFormDisposeVisible = true;
    },
    handleReturnVisit: function handleReturnVisit(id, flowNum) {
      this.complaintId = id;
      this.flowNum = flowNum;
      this.title = '新增客户回访';
      this.dialogFormReturnVisible = true;
    }
  }
};